"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports.ScaledBox = exports.Textarea = exports.InputFooterText = exports.InputDropdownOptionCheck = exports.InputDropdownOptionLabel = exports.InputDropdownOption = exports.InputDropdownOptionsContainer = exports.InputClearAndDropdownSeparator = exports.InputBoxRightComponentContainer = exports.MaskedInputBox = exports.InputBox = exports.InputLabel = exports.InputContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

var _containers = require("./containers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  transform: scale(0.8);\n  transform-origin: left top;\n  position: relative;\n  width: ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: ", ";\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  outline: none;\n  border-radius: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ::placeholder {\n    color: ", ";\n  }\n  :focus {\n    border-color: ", ";\n  }\n  background-color: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  padding: ", ";\n  ", "\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-content: flex-end;\n  flex: none;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1;\n  font-size: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: ", ";\n  padding: 1rem 0.6rem;\n  border-radius: 0.4rem;\n  :hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 100;\n  padding: 0.6rem;\n  position: absolute;\n  width: 100%;\n  top: 0.5rem;\n  border-width: 0.1rem;\n  border-style: solid;\n  border-radius: 0.5rem;\n  border-color: ", ";\n  background-color: #fff;\n  -webkit-box-shadow: 0.2rem 0.3rem 0.3rem #e8e8e8;\n  box-shadow: 0.2rem 0.3rem 0.3rem #e8e8e8;\n  max-height: 28rem;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: stretch;\n  background-color: hsl(0, 0%, 80%);\n  margin-bottom: 0.8rem;\n  margin-top: 0.8rem;\n  margin-left: 0.3rem;\n  margin-right: 0.3rem;\n  width: 0.1rem;\n  box-sizing: border-box;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      border: none;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  transform: translateX(-0.1rem);\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: ", ";\n  outline: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  border-radius: 0 0.5rem 0.5rem 0;\n  padding-left: 0.4rem;\n  background-color: ", ";\n  font-size: ", ";\n  /* overflow: hidden; */\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  & > input {\n    width: 100%;\n    flex: 1;\n    padding: ", ";\n    border-width: ", ";\n    border-style: solid;\n    border-color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    outline: none;\n    border-radius: ", ";\n    text-overflow: ellipsis;\n    overflow: hidden;\n    ::placeholder {\n      color: ", ";\n    }\n    :focus {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: ", ";\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  outline: none;\n  border-radius: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ", "\n    ::placeholder {\n    color: ", ";\n  }\n  :disabled {\n    opacity: 1;\n  }\n  :focus {\n    border-color: ", ";\n  }\n  background-color: ", ";\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: ", ";\n  padding: ", ";\n  color: ", ";\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n  ", "\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var scaleSize = function scaleSize(size) {
  return (1.33 * size).toFixed(1) + "rem";
};

var InputContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.flex ? "flex: " + props.flex + ";" : "";
}, function (props) {
  return props.margin ? "margin: " + props.margin + ";" : "";
}, function (props) {
  return props.width ? "" + props.width : "100%";
});

exports.InputContainer = InputContainer;

var InputLabel = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.fontSize || "1.2rem";
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.padding || "0 0 0.6rem 0";
}, function (props) {
  return props.color || "";
}, function (props) {
  return !props.children ? ":after {\n    content: \"\\200b\";\n  }" : "";
});

exports.InputLabel = InputLabel;

var InputBox = _styledComponents["default"].input(_templateObject3(), function (props) {
  return props.inputPadding || "1.2rem 1.2rem";
}, function (props) {
  return props.hasRightComponent ? "1px 0 1px 1px" : "1px";
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : props.dropdownDisplayed ? _theme["default"]["default"].primary : _theme["default"]["default"].grey;
}, function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.hasRightComponent ? "0.5rem 0 0 0.5rem" : "0.5rem";
}, function (props) {
  return props.maxHeight ? "max-height: " + props.maxHeight + ";" : "";
}, function (props) {
  return props.placeholderTextColor || _theme["default"]["default"].grey75P;
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : _theme["default"]["default"].primary;
}, function (props) {
  return props.backgroundColor || "transparent";
});

exports.InputBox = InputBox;

var MaskedInputBox = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.inputPadding || "1rem 1.2rem";
}, function (props) {
  return props.hasRightComponent ? "1px 0 1px 1px" : "1px";
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : props.dropdownDisplayed ? _theme["default"]["default"].primary : _theme["default"]["default"].grey;
}, function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.hasRightComponent ? "0.5rem 0 0 0.5rem" : "0.5rem";
}, function (props) {
  return props.placeholderTextColor || _theme["default"]["default"].grey75P;
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : _theme["default"]["default"].primary;
});

exports.MaskedInputBox = MaskedInputBox;

var InputBoxRightComponentContainer = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : props.dropdownDisplayed || props.isFocused ? _theme["default"]["default"].primary : _theme["default"]["default"].grey;
}, function (props) {
  return props.backgroundColor || "transparent";
}, function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
}, function (props) {
  return props.noRightComponentBorder && (0, _styledComponents.css)(_templateObject6());
});

exports.InputBoxRightComponentContainer = InputBoxRightComponentContainer;

var InputClearAndDropdownSeparator = _styledComponents["default"].div(_templateObject7());

exports.InputClearAndDropdownSeparator = InputClearAndDropdownSeparator;

var InputDropdownOptionsContainer = _styledComponents["default"].div(_templateObject8(), function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : _theme["default"]["default"].grey50P;
});

exports.InputDropdownOptionsContainer = InputDropdownOptionsContainer;

var InputDropdownOption = _styledComponents["default"].div(_templateObject9(), function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
}, _theme["default"]["default"].grey25P);

exports.InputDropdownOption = InputDropdownOption;

var InputDropdownOptionLabel = _styledComponents["default"].div(_templateObject10(), function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
});

exports.InputDropdownOptionLabel = InputDropdownOptionLabel;
var InputDropdownOptionCheck = (0, _styledComponents["default"])(InputDropdownOptionLabel)(_templateObject11());
exports.InputDropdownOptionCheck = InputDropdownOptionCheck;

var InputFooterText = _styledComponents["default"].div(_templateObject12(), function (props) {
  return props.fontSize || "1.3rem";
}, function (props) {
  return props.padding || "0.7rem 0";
}, function (props) {
  return props.error ? "color: red;" : props.color ? "color: " + props.color + ";" : "";
}, function (props) {
  return props.italic ? "font-style: italic;" : "";
});

exports.InputFooterText = InputFooterText;

var Textarea = _styledComponents["default"].textarea.attrs(function (props) {
  return {
    rows: props.rows ? props.rows : 2
  };
})(_templateObject13(), function (props) {
  return props.inputPadding || "1rem 1.2rem";
}, function (props) {
  return props.hasRightComponent ? "1px 0 1px 1px" : "1px";
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : props.dropdownDisplayed ? _theme["default"]["default"].primary : _theme["default"]["default"].grey;
}, function (props) {
  return props.fontSize && scaleSize(props.fontSize) || "1.6rem";
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.hasRightComponent ? "0.5rem 0 0 0.5rem" : "0.5rem";
}, function (props) {
  return props.placeholderTextColor || _theme["default"]["default"].grey75P;
}, function (props) {
  return props.error ? _theme["default"]["default"].secondaryPomegranate : _theme["default"]["default"].primary;
}, function (props) {
  return props.backgroundColor || "transparent";
});

exports.Textarea = Textarea;
var ScaledBox = (0, _styledComponents["default"])(_containers.Container)(_templateObject14(), function (props) {
  return props.width ? props.width : '125%';
});
exports.ScaledBox = ScaledBox;